import { cn } from '@/shared/utils/cn';
import { VisualSlotType, IconFontColor } from '@/shared/types/types';
import React from 'react';
import { ListItemDefault } from '../molecules/ListItemDefault';

export interface ListDefaultItem {
  id: string;
  label: string;
  icon?: VisualSlotType;
  iconColor?: IconFontColor;
  disabled?: boolean;
  color?: 'blue' | 'red';
}

export interface ListDefaultProps {
  items: ListDefaultItem[];
  currentValue?: string;
  onItemClick?: (item: ListDefaultItem) => void;
  className?: string;
}

export const ListDefault: React.FC<ListDefaultProps> = ({
  items,
  currentValue,
  onItemClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-min-w-[208px]',
        className,
      )}
    >
      <ul className="ui-m-0 ui-flex ui-list-none ui-flex-col ui-gap-8 ui-p-0">
        {items.map((item) => (
          <ListItemDefault
            key={item.id}
            icon={item.icon}
            iconColor={item.iconColor}
            disabled={item.disabled}
            current={currentValue === item.id}
            color={item.color}
            onClick={() => onItemClick?.(item)}
          >
            {item.label}
          </ListItemDefault>
        ))}
      </ul>
    </div>
  );
};
